import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { cx } from "class-variance-authority";
import { Calendar } from "lucide-react";

export const InputDate = ({
  value,
  onChange,
  onBlur,
  className,
  formatType = "date",
  ...props
}) => {
  const handleSelect = (date) => {
    if (!date) {
      onChange("");
      return;
    }

    if (formatType === "datetime") {
      // Format: yyyy-MM-dd HH:mm
      const formatted = date.toISOString().slice(0, 16).replace("T", " ");
      onChange(formatted);
    } else {
      // Format: yyyy-MM-dd
      onChange(date.toISOString().split("T")[0]);
    }
  };

  const handleCalendarClose = () => {
    if (onBlur) {
      onBlur();
    }
  };

  const dateValue = value ? new Date(value) : null;

  const showTimeSelect = formatType === "datetime";
  const dateFormat =
    formatType === "datetime" ? "yyyy-MM-dd HH:mm" : "yyyy-MM-dd";

  return (
    <DatePicker
      selected={dateValue}
      onChange={handleSelect}
      onCalendarClose={handleCalendarClose}
      dateFormat={dateFormat}
      showTimeSelect={showTimeSelect}
      timeFormat="HH:mm"
      className={cx(
        "rounded-md border border-gray-400 !pl-8 !pr-4 !py-3",
        "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
        "transition duration-300 ease-in-out disabled:bg-gray-100",
        "flex items-center justify-between w-full",
        className,
      )}
      showIcon
      icon={
        <Calendar className="w-4 h-4 text-gray-500 top-1/2 -translate-y-1/2" />
      }
      {...props}
    />
  );
};

export const InputDateGroup = ({ label, formatType = "date", ...props }) => {
  return (
    <div className="grid grid-cols-1 gap-3">
      {label && (
        <span className="font-bold text-[16px] capitalize mt-3">{label}</span>
      )}
      <div className="col-span-1 md:col-span-2 flex flex-col">
        <InputDate formatType={formatType} {...props} />
      </div>
    </div>
  );
};
